<ng-container #cont></ng-container>
<ng-template #xBtnTmp>
    <div class="banner__close">
        <svg (click)=" close()" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="16" height="16" rx="7.99998"/>
            <rect width="9.33333" height="0.999999" rx="0.5" transform="matrix(0.707109 0.707105 -0.707109 0.707105 5.05347 4.34668)"/>
            <rect width="9.33333" height="0.999999" rx="0.5" transform="matrix(0.707109 -0.707105 0.707109 0.707105 4.34644 10.9463)"/>
        </svg>
    </div>
</ng-template>

